import { render, staticRenderFns } from "./BanManagement.vue?vue&type=template&id=172631de&scoped=true"
import script from "./BanManagement.vue?vue&type=script&lang=js"
export * from "./BanManagement.vue?vue&type=script&lang=js"
import style0 from "./BanManagement.vue?vue&type=style&index=0&id=172631de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172631de",
  null
  
)

export default component.exports